import { render } from "./AgeCalc.vue?vue&type=template&id=019df382"
import script from "./AgeCalc.vue?vue&type=script&lang=js"
export * from "./AgeCalc.vue?vue&type=script&lang=js"

import "./AgeCalc.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__